import { Group, Text, type TextProps } from '@mantine/core';
import { useMantineColorScheme } from '@mantine/core';

const MARKS = {
  brand: '/logo-mark.svg',
  mono: '/logo-mark-mono.svg',
  reversed: '/logo-mark-reversed.svg',
} as const;

type MarkTone = keyof typeof MARKS;

type LogoProps = {
  variant?: 'lockup' | 'mark';
  /** Mark size in px */
  size?: number;
  /** Override automatic light/dark mark selection */
  tone?: MarkTone;
  wordmarkSize?: TextProps['fz'];
};

export function Logo({
  variant = 'lockup',
  size = 32,
  tone,
  wordmarkSize = 'lg',
}: LogoProps) {
  const { colorScheme } = useMantineColorScheme();
  const resolvedTone: MarkTone = tone ?? (colorScheme === 'dark' ? 'reversed' : 'brand');

  return (
    <Group gap="sm" wrap="nowrap" align="center">
      <img
        src={MARKS[resolvedTone]}
        alt=""
        width={size}
        height={size}
        decoding="async"
        style={{ display: 'block', flexShrink: 0 }}
      />
      {variant === 'lockup' && (
        <Text fw={600} fz={wordmarkSize} style={{ letterSpacing: '-0.03em', lineHeight: 1 }}>
          seidhi
        </Text>
      )}
    </Group>
  );
}
